import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { 
  FaHome, 
  FaList, 
  FaCogs, 
  FaDownload,
  FaUserCheck,
  FaFileInvoiceDollar,
  FaUserFriends 
} from "react-icons/fa";
import "../../App.css";
import CureBayLogo from "../../assets/images/CureBayLogo.svg";
import { APP_ROUTES } from "../../routes/approutes";

const NavBar = () => {
  const [activeTab, setActiveTab] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const roleCode = localStorage.getItem('userRole');

  const baseTabs = [
    {
      id: 0,
      name: "Home",
      icon: FaHome,
      route: APP_ROUTES.DASHBOARD,
    },
    {
      id: 1,
      name: "Enquiry List",
      icon: FaList,
      route: APP_ROUTES.ENQLIST,
    },
    {
      id: 2,
      name: "Services",
      icon: FaCogs,
      route: APP_ROUTES.SERVICE,
    }
  ];

  const adminTabs = [
    {
      id: 3,
      name: "Downloads",
      icon: FaDownload,
      route: APP_ROUTES.DOWNLOAD,
    },
    {
      id: 4,
      name: "Agent Reports",
      icon: FaUserFriends,
      route: APP_ROUTES.AGENT_REPORTS,
    }
  ];

  const praTabs = [
    {
      id: 1,
      name: "Patient Approval",
      icon: FaUserCheck,
      route: APP_ROUTES.PRALIST,
    },
    {
      id: 2,
      name: "Billing Approval",
      icon: FaFileInvoiceDollar,
      route: APP_ROUTES.BILLAPPROVE,
    }
  ];

  useEffect(() => {
    let currentTabs;
    if (roleCode === 'PRADMIN') {
      currentTabs = [...praTabs];
      if (roleCode === 'GROUPPRADMIN' || roleCode === 'ACCADMIN') {
        currentTabs = [...praTabs, ...adminTabs];
      }
    } else {
      currentTabs = [...baseTabs];
      if (roleCode === 'GROUPPRADMIN' || roleCode === 'ACCADMIN') {
        currentTabs = [...baseTabs, ...adminTabs];
      }
    }

    const currentTab = currentTabs.find((tab) => tab.route === location.pathname);
    setActiveTab(currentTab?.id || null);
  }, [location, roleCode]);

  const handleNavigation = (path, tabId) => {
    setActiveTab(tabId);
    history.push(path);
  };

  const getCurrentTabs = () => {
    if (roleCode === 'PRADMIN') {
      if (roleCode === 'GROUPPRADMIN' || roleCode === 'ACCADMIN') {
        return [...praTabs, ...adminTabs];
      }
      return praTabs;
    }
    
    if (roleCode === 'GROUPPRADMIN' || roleCode === 'ACCADMIN') {
      return [...baseTabs, ...adminTabs];
    }
    
    return baseTabs;
  };

  const currentTabs = getCurrentTabs();

  return (
    <div className="flex flex-col w-[15%] h-[100%] bg-[#18406E] fixed z-[1]">
      <div className="flex items-center justify-start p-4">
        <img src={CureBayLogo} alt="Company Logo" className="h-8" />
      </div>
      
      {currentTabs.map((tab) => {
        const IconComponent = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => handleNavigation(tab.route, tab.id)}
            className={`flex items-center mt-2 cursor-pointer relative w-full text-left ${
              activeTab === tab.id ? "text-[#18406E]" : "text-white"
            }`}
          >
            <div
              className={`absolute inset-0 bg-white w-full h-[50px] rounded-l-full ${
                activeTab !== tab.id && "hidden"
              }`}
              style={{ zIndex: 0 }}
            />
            <div className="flex items-center z-10 p-3 ml-4">
              <IconComponent 
                className={`mr-3 ${
                  activeTab === tab.id ? "text-[#18406E]" : "text-white"
                }`}
                size={20}
              />
              <span
                className="text-sm font-bold"
                style={{ whiteSpace: "nowrap" }}
              >
                {tab.name}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default NavBar;